

































import { Vue, Prop } from 'vue-property-decorator'
import Component from 'vue-class-component'
import { Routes } from '@/router/routes'
import Tax from '@/dto/taxes/Tax'
import Country from '@/dto/deliveries/Country'
import DictionariesService from '@/services/DictionariesService'
import Currency from '@/dto/deliveries/Currency'
import TaxDeleteForm from '@/components/tax/TaxDeleteForm.vue'

@Component({
  components: { TaxDeleteForm },
})
export default class TaxesTableRow extends Vue {
  @Prop(Object)
  public tax: Tax

  @Prop(Object)
  public props: any

  @Prop(Array)
  public countries: Country[]

  isShowConfirmDialog: boolean = false

  get fromCountry() {
    return this.countries.find(
      country => country.id === (this.tax.fromCountryId as number)
    )
  }

  get toCountry() {
    return this.countries.find(
      country => country.id === (this.tax.toCountryId as number)
    )
  }

  get currency(): Currency {
    const currency = this.tax.currencyCode as string
    return DictionariesService.currencies[currency]
  }

  selectTax() {
    const taxId = this.tax.id as number

    if (this.$route.params.taxId !== taxId.toString())
      this.$router.push({
        name: Routes.taxEdit,
        params: { taxId: taxId.toString() },
      })
  }
}
